import React from 'react'
import { Button, Input, Modal, ModalBody, ModalHeader } from 'reactstrap'

function AddNewCityModal(props) {

    return (
        <Modal isOpen={props.isOpen} toggle={() => { props.onCancel() }} centered>
            <ModalHeader toggle={() => { props.onCancel() }}>Add New City</ModalHeader>
            <ModalBody>
                <div className="mb-4">
                    <span>Add a new city for state: <strong> {props?.stateName}</strong></span>
                </div>

                <Input
                    type="text"
                    placeholder="Enter city name"
                    value={props?.cityName}
                    onChange={(e) => props.setCityName(e.target.value)}
                />
                <div className="d-flex justify-content-end mt-5">
                    <Button
                        color="secondary"
                        className="mr-2 px-4 py-2"
                        type="button" onClick={props.onCancel}>
                        Cancel
                    </Button>
                    <Button
                        color="primary"
                        className="btn-deep-blue mr-2 px-4 py-2"
                        type="button"
                        onClick={() => props.onSave(props?.stateID)}>
                        {props.showLoader ? <i className="fa fa-spinner fa-spin mr-2"></i> :
                            "Save"}
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default AddNewCityModal